// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { cronoszkEVMTestnet as _cronoszkEVMTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the cronoszkEVMTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 282
 * Chain Name: Cronos zkEVM Testnet
 * Default Block Explorer: https://explorer.zkevm.cronos.org/testnet
 * Default RPC URL: https://testnet.zkevm.cronos.org
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { cronoszkEVMTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: cronoszkEVMTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const cronoszkEVMTestnet = createCommon({
	..._cronoszkEVMTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
